(() => {
  let observer = new IntersectionObserver(function(entries) {
    for(let i = 0; i < entries.length; i++) {
      if(entries[i].isIntersecting === true) {
        entries[i].target.classList.add('intersect')
        entries[i].target.dispatchEvent(new CustomEvent('intersect', { detail: { isIntersecting: true }}))
      } else {
        entries[i].target.classList.remove('intersect')
        entries[i].target.dispatchEvent(new CustomEvent('intersect', { detail: { isIntersecting: false }}))
      }
    }
  }, { threshold: [1] })

  document.querySelectorAll('.intersect-observe').forEach(value => observer.observe(value))
})()
